import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { API } from '@const'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import * as utils from '@utils'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'

class EngineManagementPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EngineManagementPage')
        }
    }

    state = {
        game_list: [],
        server_close_info: {},
        close_check_info: {},
    }

    componentDidMount() {
        this.queryData(true)
    }

    queryData = (hideToast) => {
        utils.apiRequest(
            'get',
            API.PLAYER_ONLINE_COUNT_EACH_GAME,
            {},
            (data) => {
                data.game_list = data.game_list.sort((a, b) => {
                    return a.game_code === 'Lobby' || b.game_code === 'Lobby'
                        ? a.game_code === 'Lobby'
                            ? -1
                            : 1
                        : a.game_code.localeCompare(b.game_code)
                })

                let totalPlayerCount = 0
                for (const idx in data.game_list) {
                    if (data.game_list[idx].game_code === 'Lobby') {
                        continue
                    }

                    totalPlayerCount += data.game_list[idx].player_count
                }
                data.game_list = [{ game_code: 'gamesTotal', player_count: totalPlayerCount }].concat(data.game_list)
                this.setState({ game_list: data.game_list })
            },
            (_err) => {},
            hideToast
        )

        utils.apiRequest(
            'get',
            API.SYSTEM_CLOSE_SERVER,
            {},
            (data) => {
                this.setState({ server_close_info: data })
            },
            (_err) => {},
            hideToast
        )

        utils.apiRequest(
            'get',
            API.SYSTEM_CLOSE_CHECK,
            {},
            (data) => {
                this.setState({ close_check_info: data })
            },
            (_err) => {},
            hideToast
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Button variant="contained" onClick={() => this.queryData(false)} color="primary" style={{ marginRight: '12px' }}>
                        {'重新整理'}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'info',
                                msg: '確認關閉伺服器',
                                confirm: (_params) => {
                                    utils.apiRequest(
                                        'post',
                                        API.SYSTEM_CLOSE_SERVER,
                                        {
                                            enable: true,
                                            close_at: utils.datetimeToUnix(utils.currentDatetime()),
                                        },
                                        (_data) => {
                                            this.queryData(true)
                                            this.confirmDialog.closeDialog()
                                        }
                                    )
                                },
                            })
                        }}
                        color="primary"
                        style={{ marginRight: '12px' }}>
                        {'關閉伺服器'}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'info',
                                msg: '確認開啟伺服器',
                                confirm: (_params) => {
                                    utils.apiRequest(
                                        'post',
                                        API.SYSTEM_CLOSE_SERVER,
                                        {
                                            enable: false,
                                            close_at: utils.datetimeToUnix(utils.currentDatetime()),
                                        },
                                        (_data) => {
                                            this.queryData(true)
                                            this.confirmDialog.closeDialog()
                                        }
                                    )
                                },
                            })
                        }}
                        color="primary"
                        style={{ marginRight: '12px' }}>
                        {'開啟伺服器'}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    關閉伺服器開關狀態：
                    {this.state.server_close_info.enable === true ? '已設置關閉' : '未設置關閉'}
                </Grid>
                <Grid item xs={12}>
                    [ 伺服器狀態 ] 可關閉：
                    {this.state.close_check_info.is_close_ok ? 'true' : 'false'}
                    , 注單數：{this.state.close_check_info.bet_record_num}, 遊玩數：
                    {this.state.close_check_info.playing_num}, 局紀錄數：
                    {this.state.close_check_info.round_record_num}
                </Grid>
                <Grid item xs={12}>
                    <Paper className={this.props.classes.root}>
                        <Toolbar>
                            <Typography variant="h6">線上玩家人數</Typography>
                        </Toolbar>
                        <Table className={this.props.classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>遊戲名稱</TableCell>
                                    <TableCell>玩家人數</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.game_list.map((item) => {
                                    return (
                                        <TableRow key={item.game_code}>
                                            <TableCell>
                                                {item['game_code'] === 'gamesTotal' ? '所有遊戲 (大廳除外)' : this.t('GameName.' + item['game_code'])}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    color: item['player_count'] === 0 ? '#000' : '#f00',
                                                }}>
                                                {item['player_count']}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EngineManagementPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(EngineManagementPage)
